import { View } from 'native-base';
import { ScrollView } from 'react-native';

import { AddMoreButtonsSection } from './add-more-buttons-section';
import { DeliveryFeesSection } from './delivery-fees-section';
import { DonationsSection } from './donations-section';
import { FoodwareSection } from './foodware-section';
import { UpsellSection } from './upsell-section';
import { YourCartSection } from './your-cart-section';

export const CartContent = () => {
  return (
    <ScrollView>
      <View style={{ gap: 16 }}>
        <YourCartSection />
        <AddMoreButtonsSection />
        <UpsellSection />
        <FoodwareSection />
        <DonationsSection />
        <DeliveryFeesSection />
      </View>
    </ScrollView>
  );
};
